import { VENDOR_BOOKINGS_DATA_ALRAJHI, VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI, VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI, VENDOR_BOOKINGS_DATA_EMPTY_ALRAJHI } from '../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorBookingsAlrajhi = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_BOOKINGS_DATA_ALRAJHI:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action?.payload,
      };
      break;

    case VENDOR_BOOKINGS_DATA_EMPTY_ALRAJHI:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorBookingsAlrajhi;
